import { useParams } from 'react-router-dom';
import { useUser_GetCurrentUser_WithPortalMembershipsQuery } from 'queries';

import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

export default function PortalName() {
  const { portalId } = useParams<Record<string, string>>();

  const { data: userData, loading: userLoading } =
    useUser_GetCurrentUser_WithPortalMembershipsQuery({
      onError: (e) => {
        showAlert({
          message: 'Error getting current user with portal memberships: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (!userData || userLoading) {
    return <Spinner />;
  }

  const portalMembership = (userData.data.portalMemberships || []).find(
    (membership) => membership.portal?.id === portalId,
  );

  const portalMembershipName = portalMembership?.portal?.name || 'Invalid Portal Membership';

  return <>{portalMembershipName}</>;
}
